//@ts-ignore
import {CirclePicker} from 'webtic-react-color'
import {pickerColors} from '../../../constants/pickerColors'
import cssMobile from '../../../css/editorMobile.module.css'
import {useAppDispatch, useAppSelector} from '../../../stores/configureStore'
import {handleUpdatedAttributes} from '../../../utils/helpers/attributeHelper'
import ControlsBase from './ControlsBase'

interface ControlsProps {
  open: boolean
  onBackClick?: () => void
}

export default function ColorControls({open, onBackClick}: ControlsProps) {
  const dispatch = useAppDispatch()
  const selectedImage = useAppSelector(store =>
    store.editor.images.find(
      image => image.id === store.editor.selectedImageId,
    ),
  )

  return (
    <ControlsBase open={open} onBackClick={onBackClick}>
      {selectedImage?.type === 'caption' && (
        <div className={cssMobile.controlItemsRow}>
          <CirclePicker
            colors={pickerColors}
            width="100%"
            color={selectedImage.color}
            onChange={(color: any) => {
              handleUpdatedAttributes(dispatch, selectedImage, {
                color: color.hex,
              })
            }}
          />
        </div>
      )}
    </ControlsBase>
  )
}
